const routes = [
  {
    path: "/crm",
    name: "crm",
    label: "CRM",
    component: () => import("@/components/crm/MenuCRM.vue"),
  },
  {
    path: "/crm/negocios/funis",
    name: "crm.funis",
    label: "Funis",
    component: () => import("@/components/crm/funis/CrmFunis.vue"),
  },
  {
    path: "/crm/negocios",
    name: "crm.negocios.menu",
    label: "Negócios",
    component: () => import("@/components/crm/negocios/MenuCrmNegocios.vue"),
  },
  {
    path: "/crm/negocios/kanban",
    name: "crm.negocios",
    label: "Kanban de Negócios e Leads",
    component: () => import("@/components/crm/negocios/kanban.vue"),
  },
  {
    path: "/crm/negocios/:id",
    name: "crm.negocios.editar",
    label: "Editar Negócios",
    component: () => import("@/components/crm/negocios/edit.vue"),
  },
  {
    path: "/crm/negocios/leads",
    name: "crm.leads",
    label: "Visualizar Leads",
    component: () => import("@/components/crm/negocios/leads.vue"),
  },
  {
    path: "/crm/negocios/relatorios",
    name: "crm.relatorios",
    label: "Dashboard Gerencial",
    component: () => import("@/components/crm/negocios/relatorios.vue"),
  },
  {
    path: "/crm/negocios/relatorios/tarefas",
    name: "crm.relatorios.tarefas",
    label: "Relatório de Tarefas",
    component: () => import("@/components/crm/relatorios/ViewCrmRelatorioTarefas.vue"),
    meta: { requiresAuth: true },
  },
  { path: "/crm/equipes/relatorio-tarefas", redirect: { name: "crm.relatorios.tarefas" } },
  { path: "/crm/relatorios/tarefas", redirect: { name: "crm.relatorios.tarefas" } },
  {
    path: "/crm/agenda",
    name: "crm.agenda.menu",
    label: "Agenda",
    component: () => import("@/components/crm/agenda/MenuCrmAgenda.vue"),
  },
  {
    path: "/crm/agenda/calendario",
    name: "crm.agenda",
    label: "Agenda",
    component: () => import("@/components/crm/agenda/ViewCrmAgenda.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/crm/agenda/configuracoes",
    name: "crm.agenda.configuracoes",
    label: "Configurações da Agenda",
    component: () => import("@/components/crm/agenda/ViewCrmAgendaConfiguracoes.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/crm/equipes",
    name: "crm.equipes.menu",
    label: "Equipes",
    component: () => import("@/components/crm/equipes/MenuCrmEquipes.vue"),
  },
  {
    path: "/crm/equipes/gerenciar",
    name: "crm.equipes",
    label: "Equipes",
    component: () => import("@/components/crm/equipes/ViewCrmEquipes.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/crm/equipes/:id",
    name: "crm.equipes.editar",
    label: "Editar Equipe",
    component: () => import("@/components/crm/equipes/ViewCrmEquipeEditar.vue"),
    // Mesma permissão da listagem; gravação continua em crm.equipes.gerenciar
    meta: { requiresAuth: true, permission: "crm.equipes" },
  },
  {
    path: "/crm/equipes/metricas-time",
    name: "crm.metricas-time",
    label: "Métricas do Time",
    component: () => import("@/components/crm/relatorios/ViewCrmMetricasTime.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/crm/equipes/indicadores-performance",
    name: "crm.relatorios.indicadores",
    label: "Indicadores de Performance",
    component: () => import("@/components/crm/relatorios/ViewCrmIndicadoresPerformance.vue"),
    meta: { requiresAuth: true },
  },
  { path: "/crm/relatorios/indicadores-performance", redirect: { name: "crm.relatorios.indicadores" } },
  {
    path: "/crm/equipes/regioes-comerciais",
    name: "crm.regioes-comerciais",
    label: "Regiões Comerciais",
    component: () => import("@/components/crm/regioes/ConfiguracaoRegioesComerciais.vue"),
    meta: { requiresAuth: true },
  },
  { path: "/crm/regioes-comerciais", redirect: { name: "crm.regioes-comerciais" } },
  {
    path: "/crm/metas",
    name: "crm.metas",
    label: "Metas",
    component: () => import("@/components/crm/metas/DashboardMetasCrm.vue"),
    meta: { requiresAuth: true, permission: "crm.metas" },
  },
  {
    path: "/crm/metas/analise-mensal",
    name: "crm.metas.analise-mensal",
    label: "Análise Mensal de Metas",
    component: () => import("@/components/crm/metas/AnaliseMensalMetasCrm.vue"),
    meta: { requiresAuth: true, permission: "crm.metas" },
  },
  {
    path: "/crm/metas/meu-desempenho",
    name: "crm.metas.meu-desempenho",
    label: "Meu Desempenho",
    component: () => import("@/components/crm/meu-desempenho/MeuDesempenhoCrm.vue"),
    // Sem `permission`: sem isso, o guard cai pro nome da rota como chave de permissão e
    // bloqueia todo mundo sem essa string exata cadastrada em algum perfil. O controle de quem
    // vê os dados de quem já é feito pela API (usuarioPodeVisualizarConsultor).
    meta: { requiresAuth: true, skipPermissionCheck: true },
  },
  {
    path: "/crm/metas/comissionamento",
    name: "crm.comissao.configurar",
    label: "Comissionamento",
    component: () => import("@/components/crm/comissao/ConfiguracaoFaixasComissao.vue"),
    meta: { requiresAuth: true, permission: "crm.comissao.configurar" },
  },
  // Compatibilidade com URLs antigas (menu abre por prefixo /crm/metas)
  { path: "/crm/meu-desempenho", redirect: { name: "crm.metas.meu-desempenho" } },
  { path: "/crm/comissao/faixas", redirect: { name: "crm.comissao.configurar" } },
  {
    path: "/crm/rdstation",
    name: "crm.rdstation",
    label: "Integração com RD Station",
    component: () => import("@/components/crm/IntegracaoRDStation.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/crm/orcamentos",
    name: "crm.orcamentos",
    label: "Orçamentos",
    component: () => import("@/components/crm/orcamentos/MenuOrcamentos.vue"),
  },
  {
    path: "/crm/orcamentos/gerenciar",
    name: "crm.orcamentos.gerenciar",
    label: "Gerenciar Orçamentos",
    component: () => import("@/components/crm/orcamentos/GerenciarOrcamentos.vue"),
  },
  {
    path: "/crm/orcamentos/novo",
    name: "crm.orcamentos.novo",
    label: "Novo Orçamento",
    component: () => import("@/components/crm/orcamentos/FormOrcamento.vue"),
  },
  {
    path: "/crm/orcamentos/:id",
    name: "crm.orcamentos.show",
    label: "Visualizar Orçamentos",
    component: () => import("@/components/crm/orcamentos/ShowOrcamento.vue"),
  },
  {
    path: "/crm/orcamentos/pendencias",
    name: "crm.orcamentos.pendencias",
    label: "Gestão de Pendências",
    component: () => import("@/components/crm/orcamentos/GerenciarPendenciasProducao.vue"),
  },
  {
    path: "/crm/orcamentos/configuracoes",
    name: "crm.orcamentos.configuracoes",
    label: "Configurações de Orçamentos",
    component: () => import("@/components/crm/orcamentos/ConfiguracoesOrcamentos.vue"),
  },
  {
    path: "/crm/orcamentos/projetos",
    name: "crm.orcamentos.projetos",
    label: "Projetos",
    component: () => import("@/components/crm/orcamentos/CrmOrcamentoProjetos.vue"),
    meta: { requiresAuth: true, permission: "crm.orcamentos.projetos.gerenciar" },
  },
  {
    path: "/crm/orcamentos/templates/novo",
    name: "crm.orcamentos.templates.novo",
    label: "Novo Template",
    component: () => import("@/components/crm/orcamentos/TemplateOrcamentoForm.vue"),
  },
  {
    path: "/crm/orcamentos/templates/:id/editar",
    name: "crm.orcamentos.templates.editar",
    label: "Editar Template",
    component: () => import("@/components/crm/orcamentos/TemplateOrcamentoForm.vue"),
  },
  {
    path: "/crm/orcamentos/templates",
    name: "crm.orcamentos.templates",
    label: "Templates de Orçamentos",
    component: () => import("@/components/crm/orcamentos/TemplatesOrcamentos.vue"),
  },
  {
    path: "/crm/negocios/origens-lead",
    name: "crm.origens-lead",
    label: "Origens de Leads",
    component: () => import("@/components/crm/negocios/ConfiguracaoOrigensLead.vue"),
  },
  {
    path: "/crm/negocios/campos-obrigatorios",
    name: "crm.negocios.campos-obrigatorios",
    label: "Campos Obrigatórios do Lead",
    component: () => import("@/components/crm/negocios/ConfiguracaoCamposObrigatoriosLead.vue"),
  },
  {
    path: "/crm/negocios/campanhas",
    name: "crm.negocios.campanhas",
    label: "Campanhas",
    component: () => import("@/components/crm/negocios/ConfiguracaoCampanhas.vue"),
  },
  {
    path: "/crm/negocios/tipos-tarefa",
    name: "crm.tipos-tarefa",
    label: "Tipos de Tarefa",
    component: () => import("@/components/crm/negocios/ConfiguracaoTiposTarefa.vue"),
  },
  {
    path: "/crm/negocios/tags",
    name: "crm.tags",
    label: "Tags",
    component: () => import("@/components/crm/tags/CrmTags.vue"),
  },
  {
    path: "/crm/negocios/perdas",
    name: "crm.perdas",
    label: "Motivos de Perda",
    component: () => import("@/components/crm/negocios/ConfiguracaoMotivosPerda.vue"),
  },
  {
    path: "/crm/negocios/segmentos",
    name: "crm.segmentos",
    label: "Segmentos",
    component: () => import("@/components/crm/negocios/ConfiguracaoSegmentos.vue"),
  },
  {
    path: "/crm/api-keys",
    name: "crm.api-keys",
    label: "API Keys (CRM)",
    component: () => import("@/components/crm/integracoes/CrmApiKeys.vue"),
  },
  {
    path: "/crm/campanhas",
    name: "crm.campanhas.menu",
    label: "Campanhas",
    component: () => import("@/components/crm/campanhas/MenuCrmCampanhas.vue"),
  },
  {
    path: "/crm/campanhas/gerenciar",
    name: "crm.campanhas",
    label: "Campanhas de E-mail",
    component: () => import("@/components/crm/campanhas/GerenciarCampanhas.vue"),
  },
  {
    path: "/crm/campanhas/nova",
    name: "crm.campanhas.nova",
    label: "Nova Campanha",
    component: () => import("@/components/crm/campanhas/FormCampanha.vue"),
  },
  {
    path: "/crm/campanhas/:id/editar",
    name: "crm.campanhas.editar",
    label: "Editar Campanha",
    component: () => import("@/components/crm/campanhas/FormCampanha.vue"),
    props: (route) => ({ id: route.params.id }),
  },
  {
    path: "/crm/campanhas/:id",
    name: "crm.campanhas.detalhe",
    label: "Detalhe da Campanha",
    component: () => import("@/components/crm/campanhas/CampanhaDetalhe.vue"),
  },
  {
    path: "/crm/equipes/territorios",
    name: "crm.territorio-representantes",
    label: "Territórios por Responsável",
    component: () => import("@/components/crm/territorio/ViewCrmTerritorioRep.vue"),
  },
];

export default routes;
